import MovieReviews from './MovieReviews';

export default MovieReviews;
